const token = (name: string) => `var(--fuel-color-${name})`;

const colors = {
  background: {
    brand: {
      default: token('surface-primary'),
      weakest: token('surface-primary-weakest'),
      weak: token('surface-primary-weakest'),
      medium: token('surface-primary'),
      strong: token('surface-primary-strong'),
    },
    danger: {
      default: token('surface-danger'),
      weak: token('surface-danger-weakest'),
      medium: token('surface-danger'),
      strong: token('surface-danger-strong'),
    },
    neutral: {
      default: token('background-default'),
      weak: token('background-weak'),
      strong: token('background-medium'),
      inverted: token('background-inverted'),
    },
    success: {
      default: token('surface-success'),
      weak: token('surface-success-weakest'),
      strong: token('surface-success-strong'),
    },
  },
  text: {
    brand: {
      default: token('text-primary'),
      strong: token('text-primary-strong'),
    },
    danger: {
      default: token('text-danger'),
      strong: token('text-danger-strong'),
    },
    neutral: {
      inverted: token('text-inverted'),
      weak: token('text-weak'),
      default: token('text-medium'),
      strong: token('text-strong'),
    },
    success: {
      default: token('text-success'),
      strong: token('text-success-strong'),
    },
  },
  border: {
    brand: { default: token('border-primary') },
    danger: { default: token('border-danger') },
    neutral: {
      default: token('border-weak'),
      medium: token('border-medium'),
      strong: token('border-strong'),
      inverted: token('border-inverted'),
    },
    success: { default: token('border-success') },
  },
  icon: {
    brand: { default: token('icon-primary') },
    danger: { default: token('icon-danger') },
    neutral: {
      default: token('icon-medium'),
      weak: token('icon-weak'),
      strong: token('icon-strong'),
      inverted: token('icon-inverted'),
    },
    success: { default: token('icon-success') },
  },
  hover: {
    brand: {
      default: token('surface-primary-weakest'),
      strong: token('interaction-hovered'),
    },
    danger: { weak: token('surface-danger-weakest') },
    neutral: {
      default: token('background-medium'),
      weak: token('background-weak'),
      strong: token('light-gray-800'),
    },
    success: { weak: token('surface-success-weakest') },
  },
  focus: {
    brand: { default: token('surface-primary-weakest') },
    danger: { weak: token('surface-danger-weakest') },
    neutral: {
      default: token('background-medium'),
      weak: token('background-weak'),
    },
    success: { weak: token('surface-success-weakest') },
  },
  support: {
    purple: {
      weak: token('light-purple-200'),
      strong: token('light-purple-600'),
    },
    blue: { weak: token('light-blue-200'), strong: token('light-blue-500') },
    orange: {
      weak: token('light-orange-200'),
      strong: token('light-orange-500'),
    },
    indigo: {
      weak: token('light-indigo-200'),
      strong: token('light-indigo-500'),
    },
    green: { weak: token('light-green-200'), strong: token('light-green-600') },
    yellow: {
      weak: token('surface-support-weakest'),
      strong: token('surface-support'),
    },
  },
} as const;

export default colors;
